import { FC } from 'react';
import { Button, Drawer, FormElement, Label } from '@smart-kasa/ui';
import { Form } from 'react-final-form';

import { Field, RangePicker } from 'components';
import { dateToISO8601String } from 'utils/date';
import { useShops, ShopSelectField } from 'features/shops';
import { useTerminals, TerminalSelectField } from 'features/terminals';

export interface IReportTaxesFilterForm {
  show: boolean;
  initialValues: any;
  onClose: () => void;
  onSubmit: (values) => void;
}

export const ReportTaxesFilterForm: FC<IReportTaxesFilterForm> = ({
  initialValues,
  onSubmit,
  onClose,
  ...rest
}) => {
  const { shops } = useShops();
  const { terminals } = useTerminals();

  const handleSubmit = (values) => {
    onSubmit(values);
    onClose();
  };

  return (
    <Form onSubmit={handleSubmit} initialValues={initialValues}>
      {({ handleSubmit, form, values }) => (
        <Drawer
          onClose={onClose}
          title="Фільтр"
          footer={
            <Button onClick={handleSubmit} width="full" color="primary">
              Застосувати
            </Button>
          }
          {...rest}
        >
          <FormElement label={<Label>Переглянути за датою</Label>}>
            <RangePicker
              from={values.dateStart}
              to={values.dateEnd}
              onChangeDateStart={(date) => form.change('dateStart', dateToISO8601String(date))}
              onChangeDateEnd={(date) => form.change('dateEnd', dateToISO8601String(date))}
            />
          </FormElement>

          <Field.Input
            name="query"
            label="Пошук ФН/ФН пРРО"
            placeholder="Введіть текст для пошуку"
          />

          <ShopSelectField
            name="shopId"
            label="Торгова точка"
            placeholder="Оберіть торгову точку"
            options={shops}
            isClearable
            value={Number(values.shopId)}
          />

          <TerminalSelectField
            name="terminalId"
            label="Термінал"
            placeholder="Оберіть термінал"
            options={terminals.filter((item) => item.shopId === Number(values.shopId))}
            isClearable
          />
        </Drawer>
      )}
    </Form>
  );
};
